import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserLoggedInit } from '../core/classes/UserLoggedInit';
import { CurrentUserRole } from '../core/factory/userInitFactory/types/CurrentUserRoleTypes';
import { DashboardUserRoute } from '../core/factory/userInitFactory/types/DashboardUserRouteTypes';
import { UserProfileService } from '../Services/user-profile/user-profile.service';
import { UserProfile } from '../Services/user-profile/UserProfile';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate {

  constructor(
    private router: Router,
    private userProfileService: UserProfileService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this
      .userProfileService
      .userProfileObservable()
      .pipe(
        map((user: UserProfile|null): boolean => {
          if (user && user.current_role) {
            this.doUserLoggedInitActions(user.current_role as CurrentUserRole);
            return false;
          }

          return true;
        })
      );
  }

  private doUserLoggedInitActions(currentUserRole: CurrentUserRole){
    let userLoggedInit = new UserLoggedInit(currentUserRole);
    let dashboardUserRoute:DashboardUserRoute = userLoggedInit.getDashboardUserRouteInit();

    //Direciona para a rota de inicio do usuario logado
    this.router.navigate([dashboardUserRoute]);
  }

}
